import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getLeaders: async({ dispatch, commit }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            url: 'leader',
            responseType: params.excel ? 'blob' : 'json',
            params
        }).then(res => {
            if (res.data && res.data.leaders) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
                commit('SET_LEADERS', res.data.leaders)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }

            commit('SET_LOAD', false)
        })
    }
}
